import React from "react";
import complaintsQuery from "fetchers/users/complaints";

export default function wrapper(Component) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {};
      this._isMounted = false;
      if (props.match && props.match.path !== "/signout") {
        complaintsQuery({ id: props.currentUser.id }).then(({ complaints, count }) => {
          if (this._isMounted) {
            this.setState({ count });
          }
          props.saveComplaints(complaints);
        });
      }
    }

    componentDidMount() {
      this._isMounted = true;
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    navigateToComplaint = id => {
      this.props.history.push(`/complaints/${id}`);
      this.props.closeTab();
    };

    render = () => (
      <Component
        {...this.props}
        count={this.state.count}
        navigateToComplaint={this.navigateToComplaint}
      />
    );
  };
}
